import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-donut-percentage-chart',
  templateUrl: './donut-percentage-chart.component.html',
  styleUrls: ['./donut-percentage-chart.component.scss'],
})
export class DonutPercentageChartComponent implements OnInit {
  @Input() donutChartData: any;
  @Input() width: number = 45;
  @Input() height: number = 45;
  @Input() font_size: string = '.875rem';
  @Input() multiText: boolean = false;

  margin = 4.5;
  radius: number = 0;

  constructor() {}

  ngOnInit(): void {
    this.margin = this.width / 10;
    this.radius = Math.min(this.width, this.height) / 2 - this.margin;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['donutChartData']) {
      if (!!this.donutChartData) {
        this.initChart();
      }
    }
  }

  ngAfterViewInit() {
    if (!!this.donutChartData) {
      this.initChart();
    }
  }

  initChart() {
    d3.selectAll(`#${this.donutChartData?.name}`).selectAll('svg').remove();
    const svg: any = d3
      .select(`#${this.donutChartData?.name}`)
      .append('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', `0,0, ${this.width},${this.height}`)
      .append('g')
      .attr('transform', `translate(${this.width / 2},${this.height / 2})`);
    // Create dummy data

    const data = {
      a: +this.donutChartData?.percent,
      b: 100 - this.donutChartData?.percent,
    };

    // set the color scale
    const color: any = d3.scaleOrdinal().range(this.donutChartData?.colors);

    // Compute the position of each group on the pie:
    const pie: any = d3
      .pie()
      .value((d: any) => d[1])
      .sort(null);

    const data_ready: any = pie(Object.entries(data));
    console.log(data_ready);
    // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
    svg
      .selectAll('whatever')
      .data(data_ready)
      .join('path')
      .attr(
        'd',
        d3
          .arc()
          .innerRadius(this.radius - 5) // This is the size of the donut hole
          .outerRadius(this.radius)
        // .cornerRadius((d: any) => (d.index == 0 ? 5 : 0))
      )
      .attr('fill', (d: any) => color(d.data[0]));
    svg
      .append('text')
      .attr('text-anchor', 'middle')
      .attr('dominant-baseline', 'middle')
      .text(this.donutChartData?.value)
      .style('font-size', 5);
    // if (!this.multiText) {
    //   svg
    //     .append('text')
    //     .attr('text-anchor', 'middle')
    //     .attr('dy', '0.35em')
    //     .style('fill', '#F2F2F6')
    //     .style('font-size', 10)
    //     .style('font-family', 'EYInterstate W04 Light')
    //     .text(
    //       this.donutChartData?.percent ? this.donutChartData?.percent + '%' : ''
    //     );
    // } else {
    //   // Products overview donut has multiple text at the center
    //   svg
    //     .append('text')
    //     .attr('dx', this.donutChartData?.percent === '100' ? '-1.4em' : '-.9em')
    //     .attr('dy', '-0.1em')
    //     .style('fill', '#F2F2F6')
    //     .style('font-size', '8')
    //     .style('font-family', 'EYInterstate W04 Light')
    //     .text(this.donutChartData?.name ? this.donutChartData?.name : '');
    //   svg
    //     .append('text')
    //     .attr('dx', '-.5em')
    //     .attr('dy', '1.3em')
    //     .style('fill', '#F2F2F6')
    //     .style('font-size', '8')
    //     .style('font-family', 'EYInterstate W04 Light')
    //     .text(this.donutChartData?.value);
    // }
  }
}
